import WebLayout from './InformationMessageLayout.web';
import MobileLayout from './InformationMessageLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
